import { render, staticRenderFns } from "./DialogContent.vue?vue&type=template&id=1997adbb&scoped=true&"
import script from "./DialogContent.vue?vue&type=script&lang=babel&"
export * from "./DialogContent.vue?vue&type=script&lang=babel&"
import style0 from "./DialogContent.vue?vue&type=style&index=0&id=1997adbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1997adbb",
  null
  
)

export default component.exports